export enum CustomPanelSizeType {
  large = `1150px`,
  small = `550px`
}
